<template>
  <div class="buildDetails">
    <div class="top_background"></div>
    <div class="buildDetails_main">
      <!-- {{areaImgList}} -->
      <div class="buildDetails_header">
        <!-- @click="openUploadImg" -->
        <div class="house_icon" v-if="areaImgList.length==0">
          <img style="width:417px;height:298px;" src="../../assets/images/nobuild.png" alt />
        </div>
        <div v-else>
          <el-carousel style="width:380px;">
            <el-carousel-item v-for="(item,index) in areaImgList.slice(0,4)" :key="index">
              <!-- <h3>{{ item }}</h3> -->
              <img style="width:400px;height:320px;" :src="'http://'+item" alt />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!--
                <el-dialog title="置顶时间选择" width="500px" :visible.sync="atTopVisible">
                    <div class="leaveRequest_content">
                        <div class="item">
                            <div class="item_div">
                                <div>
                                    置顶时间<el-input v-model="topDate" placeholder=""></el-input>天
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div style="color:rgb(255, 71, 0)">
                                只能输入大于等于1的正整数！到期系统会自动取消置顶
                            </div>
                        </div>
                    </div>
                    <div class="dialog-foot">
                        <button class="foot-cancel" @click="atTopVisible=false">取消</button>
                        <button class="foot-save" @click="topResidentialArea">确定</button>
                    </div>
                </el-dialog> -->

        <!-- 图片上传弹窗 -->
        <el-dialog v-if="uploadImgVisible" title="上传图片" width="950px" :visible.sync="uploadImgVisible" @close="closeBtn">
          <UploadImg uploadData="05" v-if="uploadImgVisible" @cancelUpload="uploadImgVisible=false" @saveUpload="upLoadingBtn">
          </UploadImg>
        </el-dialog>

        <div class="header_content">
          <div class="header_content_text">
            <span v-if="bulidInfo.whetherOpen"></span>
            <span class="house_status" v-else><i class="iconfont icon-jiznhi" style="font-size:56px;margin-right:10px;"></i> 该楼盘状态为：禁止，暂时无法录入房源！</span>
          </div>
          <div class="header_content_title">
            <div class="header_content_title">
              <div class="content_house_name">
                <p>{{bulidInfo.name}}</p>
                <span>{{bulidInfo.areaName}}/{{bulidInfo.tradeAreaName}}</span>

              </div>
              <i v-if="isTopShow && !bulidInfo.isTop" class="iconfont icon-icon_zhiding" @click="topResidentialArea"></i>
              <i v-if="isTopShow &&  bulidInfo.isTop" class="iconfont icon-icon_quxiaozhiding" @click="topResidentialArea"></i>
              <!-- <i class="iconfont icon-icon_zhiding" @click="atTopVisible=true"></i> -->
              <p class="house_price">
                <span>{{bulidInfo.avgPrice}}</span>元/㎡
              </p>
            </div>
            <div class="header_content_title">
              <button class="manange_btn" @click="goBuildingManagement">管理楼栋</button>
              <button class="edit_btn" v-if="permisShow('小区编辑')" @click="editBasisInfo">编辑</button>
              <button class="del_btn" v-if="permisShow('删除小区')" @click="delBasisInfo">删除</button>
            </div>
          </div>
          <ul class="info_list second">
            <li class="info_list_item" @click="goBuildingManagement">
              <img src="../../assets/buildDetail/zongdongshu.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.totalTungs?bulidInfoCount.totalTungs:0}}</p>
                <p class="size_beizhu">总栋数（栋）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/zonghueshu.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.setNumber?bulidInfoCount.setNumber:0}}</p>
                <p class="size_beizhu">总户数（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/kongzhi.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.vacantNumber?bulidInfoCount.vacantNumber:0}}</p>
                <p class="size_beizhu">空置（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/zaishou.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.saleNumber?bulidInfoCount.saleNumber:0}}</p>
                <p class="size_beizhu">在售（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/zaizu.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.rentingNumber?bulidInfoCount.rentingNumber:0}}</p>
                <p class="size_beizhu">在租（套）</p>
              </div>
            </li>
          </ul>
          <ul class="info_list">
            <li class="info_list_item">
              <img src="../../assets/buildDetail/chengjiao.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.dealNumber?bulidInfoCount.dealNumber:0}}</p>
                <p class="size_beizhu">成交（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/yishou.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.soldNumber?bulidInfoCount.soldNumber:0}}</p>
                <p class="size_beizhu">已售（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/yizu.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.rentedNumber?bulidInfoCount.rentedNumber:0}}</p>
                <p class="size_beizhu">已租（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/wuxiao.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.invalidNumber?bulidInfoCount.invalidNumber:0}}</p>
                <p class="size_beizhu">无效（套）</p>
              </div>
            </li>
            <li class="info_list_item">
              <img src="../../assets/buildDetail/zanhuan.png" alt />
              <div class="list_item_size">
                <p class="size_num">{{bulidInfoCount.reprieveNumber?bulidInfoCount.reprieveNumber:0}}
                </p>
                <p class="size_beizhu">暂缓（套）</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="basis_info" style="margin-top: 30px">
        <h3 class="basis_info_title">
          <i class="icon_title"></i>基础信息
        </h3>
        <div class="basis_info_list">
          <div class="basis_info_list_item">
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">开发商：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.developers}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">物业公司：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.propertyCompany}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">物业费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.propertyFee}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">物业电话：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.propertyPhone}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">容积率：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.volumeRate}}</div>
            </div>
          </div>

          <div class="basis_info_list_item">
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">绿化率：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.greenRate}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">建筑总面积：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.buildingCovered}}&nbsp;㎡</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">占地面积：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.areaCovered}}&nbsp;㎡</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">停车方式：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.parkingModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">停车费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.parkingFee}}&nbsp;元/月</div>
            </div>
          </div>

          <div class="basis_info_list_item">
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">车位数量：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.parkingSpaces}}&nbsp;个</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商业供电：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialPowerFeeModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商业电费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialPowerFee}}元/度</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用供电：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.powerSupplyModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用电费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.powerFee}}元/度</div>
            </div>
          </div>

          <div class="basis_info_list_item">
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商业供水：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialWaterFeeModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商业水费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialWaterFee}}元/吨</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用供水：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.waterSupplyModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用水费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.waterFee}}元/吨</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商用供气：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialGasFeeModeName}}</div>
            </div>
          </div>

          <div class="basis_info_list_item">
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商业气费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialGasFee}}元/m³</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用供气：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.gasSupplyModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用气费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.gasFee}}元/m³</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商业供暖：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialWarmFeeModeName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">商用暖气费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.commercialWarmFee}}元/㎡/天</div>
            </div>
          </div>

          <div class="basis_info_list_item">
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用供暖：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.warmSupplyModelName}}</div>
            </div>
            <div class="basis_info_list_item_form">
              <div class="basis_info_list_item_label">民用暖气费：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.warmFee}}元/㎡/天</div>
            </div>
            <div class="basis_info_list_item_form" style="flex:3">
              <div class="basis_info_list_item_label">建筑类型：</div>
              <div class="basis_info_list_item_content">{{bulidInfo.architecturalTypeName}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="basis_info">
        <h3 class="basis_info_title">
          <i class="icon_title"></i> 楼盘介绍
        </h3>
        <div class="building_note">
          <p>
            <span v-if="bulidInfo.description">{{bulidInfo.description}}</span>
            <span v-else>暂无</span>
          </p>
        </div>
      </div>
      <div class="model_info">
        <h3 class="basis_info_title">
          <i class="icon_title"></i>图片信息

          <div class="dict_search_select" v-if="activeName=='houseTypeImg'">
            <div class="dict_select_item">
              <span class="year">建筑面积：</span>
              <el-input v-model="areaOfBuilding" placeholder="请输入建筑面积"></el-input>
            </div>
          </div>
        </h3>
        <!-- <button @click="uploadDoorModel">上传户型</button> -->
        <el-dialog title="新增户型" :visible.sync="newAdddoorModel" width="500px">
          <AddDoorModel v-if="newAdddoorModel" v-on:removeDoorBtn="rmoveDoorBtnAler" v-on:saveDoorBtn="saveDoorBtnAler">
          </AddDoorModel>
        </el-dialog>
        <div class="mask" v-if="imgListShow">
          <img class="close" @click="imgListShow=false,gethouseTypeList()" src="../../assets/images/close.png" alt />
          <template>
            <el-carousel indicator-position="outside" :autoplay="false" :initial-index="imgListShowIndex">
              <el-carousel-item v-for="(item,index) in curImgList" :key="index">
                <img v-if="activeName=='houseTypeImg'" :src="'http://'+item.images" alt />
                <img style="height:90%" v-else :src="'http://'+item" alt />
                <div v-if="activeName=='houseTypeImg'">
                  <ul class="door_model_info">
                    <el-upload class="upload-demo" :action="`${$uploadUrl}/erp/qiniu/uploadImg`" :data="{modularName:'05'}" :on-success="handleAvatarSuccess" :show-file-list="false" accept=".png, .jpg, .jpeg" :headers="headers">
                      <el-button size="small" style="margin-bottom: 30px;" type="primary">更换户型图
                      </el-button>
                    </el-upload>
                    <li class="door_model_info_item">
                      <span>
                        <i style="color:red;padding-right:6px;">*</i>户型
                      </span>
                      <div>
                        <input type="number" v-model="item.roomNumber" name />
                        <span>室</span>
                        <input type="number" v-model="item.officeNumber" name />
                        <span>厅</span>
                        <input type="number" v-model="item.toiletNumber" name />
                        <span>卫</span>
                        <input type="number" v-model="item.balconyNumber" name />
                        <span>阳</span>
                      </div>
                    </li>
                    <li class="door_model_area">
                      <div class="door_model_area_title">
                        <span>
                          <i style="color:red;padding-right:6px;">*</i>面积
                        </span>
                      </div>
                      <div class="door_model_input">
                        <div class="check_ture">
                          <div class="check_ture_item">
                            <input style="width: 60px" placeholder="建筑面积" v-model="item.areaOfBuilding" type="number" name />
                            <span>㎡</span>
                          </div>
                          <div class="check_ture_item">
                            <input style="width: 60px" placeholder="套内面积" v-model="item.areaOfUse" type="number" name />
                            <span>㎡</span>
                          </div>
                          <div class="check_ture_item">
<!--                            <input style="width: 60px" placeholder="分摊面积" disabled="true" v-model="(item.areaOfBuilding-item.areaOfUse).toFixed(4)" type="number" name />-->
                            <input style="width: 60px" placeholder="分摊面积" disabled="true" v-model="item.shareOfUse" type="number" name />
                            <span>㎡</span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul class="door_modle_introduced">
                    <li class="introduced_toward">
                      <span>朝向</span>
                      <el-select v-model="item.orientation">
                        <el-option v-for="(item,index) in towardData" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                      </el-select>
                    </li>
                  </ul>
                </div>
                <el-button class="edit" v-if="activeName=='houseTypeImg'&&permisShow('上传户型图')" @click="updateImg(item)" type="primary" v-points>保存</el-button>
                <el-button v-if="activeName=='houseTypeImg'&&permisShow('删除户型图')" class="delet" @click="deletImg1(item.houseTypeId)" type="danger">删除</el-button>
                <el-button v-if="activeName!='houseTypeImg'&&permisShow('删除非户型图')" class="delet" @click="deletImg(item)" type="danger">删除</el-button>
                <el-button v-if="activeName!=='houseTypeImg'" class="setCover" @click="setCover(item)" type="danger">设置封面</el-button>
                <el-button v-if="activeName=='houseTypeImg'&&ispc" class="download" @click="downLoadImg('http://'+item.images)" type="primary">下载</el-button>
                <el-button v-else class="download" @click="downLoadImg('http://'+item)" type="primary">
                  下载</el-button>
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
        <el-tabs v-model="activeName" style="margin: 30px 0 0 30px;" type="card" @tab-click="handleClick">
          <el-tab-pane label="户型图" name="houseTypeImg"></el-tab-pane>
          <el-tab-pane label="交通图" name="trafficPicture"></el-tab-pane>
          <el-tab-pane label="配套图" name="matchingPicture"></el-tab-pane>
          <el-tab-pane label="规划图" name="planningPicture"></el-tab-pane>
          <el-tab-pane label="样本图" name="templatePicture"></el-tab-pane>
          <el-tab-pane label="效果图" name="effectPicture"></el-tab-pane>
          <el-tab-pane label="外景图" name="exteriorPicture"></el-tab-pane>

        </el-tabs>
        <div class="bscroll" ref="bscroll">
          <ul class="model_info_list" v-if="activeName=='houseTypeImg'">
            <div class="model_info_list_box">
              <li class="model_info_list_item" v-for="(item,index) in doorModelData" :key="index" @click="setCurImg(item,doorModelData,index)">
                <!-- <div class="bianji">
                <i class="iconfont icon-icon_bianji"></i>
              </div>
              <div class="remove" @click="removeDoorModel(item)">
                <i class="iconfont icon-icon_shanchu"></i>
                                </div>-->
                <div class="model_info_img">
                  <img :src="'http://'+item.images" />
                </div>
                <p class="model_info_text">
                  <span>{{item.roomNumber}}室{{item.officeNumber}}厅{{item.toiletNumber}}卫</span>
                  <span>{{item.areaOfBuilding}}㎡</span>
                </p>
              </li>
              <li v-show="permisShow('上传户型图')" class="model_info_list_item upload_img_box" @click="uploadDoorModel">
                <i class="iconfont icon-icon_huxing"></i>
                <span>上传图片</span>
              </li>
            </div>
          </ul>
          <div class="footer_page" v-if="activeName=='houseTypeImg'">
            <p class="data_number">
              共
              <span>{{total}}</span>条
            </p>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="PageSize" @current-change="handleCurrentChange"></el-pagination>
          </div>
          <ul class="model_info_list" v-if="activeName!='houseTypeImg'">
            <div class="model_info_list_box">
              <li class="model_info_list_item upload_img_box" v-for="(item,index) in elseModeDara" :key="index" @click="setCurImg(item,elseModeDara,index)">
                <!-- <div class="bianji">
                  <i class="iconfont icon-icon_bianji"></i>
                </div>
                <div class="remove" @click="removeDoorModel(item)">
                  <i class="iconfont icon-icon_shanchu"></i>
                                </div>-->
                <div class="model_info_img">
                  <img class="img_fengmian" v-if="bulidInfo.cover==item" src="../../assets/images/fengmian.png" alt />
                  <img :src="'http://' + item" />
                </div>
              </li>
              <li v-show="permisShow('上传非户型图')" class="model_info_list_item upload_img_box" @click="openUploadImg(false)">
                <i class="iconfont icon-icon_huxing"></i>
                <span>上传图片</span>
              </li>
            </div>
          </ul>
          <div></div>

        </div>
      </div>
      <div class="building_info">
        <h3 class="building_info_title">
          <div>
            <i class="icon_title"></i>周边配套
          </div>
          <button v-if="permisShow('小区编辑')" style="width:88px;height:30px;background:#5E75E6;color: #fff" @click="peitaoEdit">编辑</button>
        </h3>

        <el-dialog title="配套信息" width="950px" :visible.sync="dialogTableVisible" @close="closeBtn">
          <div class="edit_alert">
            <ul class="edit_alert_list">
              <li class="edit_alert_list_item">
                <h3>周边学校</h3>
                <el-input v-model="buildData.nearbySchool" type="textarea" resize="none" placeholder="请输入周边学校信息">
                </el-input>
              </li>
              <li class="edit_alert_list_item">
                <h3>周边交通</h3>
                <el-input v-model="buildData.nearbyTraffic" type="textarea" resize="none" placeholder="请输入周边交通信息">
                </el-input>
              </li>
              <li class="edit_alert_list_item">
                <h3>周边配套</h3>
                <el-input v-model="buildData.nearbyMatch" type="textarea" resize="none" placeholder="请输入周边配套信息">
                </el-input>
              </li>
            </ul>
            <div class="edit_footer_btns">
              <el-button @click="removeSaveEditBtn">取消</el-button>
              <!-- <el-button
                  v-show="surroundInfo.school ==''&& surroundInfo.traffic==''&& surroundInfo.matching==''"
                  class="save_btn"
                  @click="addAreaFm(surroundInfo)"
                  :disabled="isSave"
                            >保存</el-button>-->
              <el-button class="save_btn" @click="modifyAreaFm()" :disabled="isSave">保存</el-button>
            </div>
          </div>
        </el-dialog>
        <ul class="building_info_list">
          <li class="building_info_list_item">
            <span>周边学校：</span>
            <span>{{bulidInfo.nearbySchool}}</span>
            <!-- <span class="building_info_list_scroll" v-for="item in scrollData">{{item}}</span> -->
          </li>
          <li class="building_info_list_item">
            <span>周边交通：</span>
            <span>{{bulidInfo.nearbyTraffic}}</span>
            <!-- <span class="building_info_list_traffic" v-for="item in trafficData">{{item}}</span> -->
          </li>
          <li class="building_info_list_item">
            <span>周边配套：</span>
            <span>{{bulidInfo.nearbyMatch}}</span>
            <!-- <span class="building_info_list_match" v-for="item in matchData">{{item}}</span> -->
          </li>
        </ul>
        <div class="address_box">
          <div id="container" style="height:100%;"></div>
          <div class="amap-page-container">
            <ul class="nav_list_box">
              <li class="nav_list_item" :class="{active: isActive=='公交'}" @click="getTraffic">公交</li>
              <li class="nav_list_item" :class="{active: isActive=='教育'}" @click="getEducation">教育</li>
              <li class="nav_list_item" :class="{active: isActive=='医疗'}" @click="getMedical">医疗</li>
              <li class="nav_list_item" :class="{active: isActive=='购物'}" @click="getShopping">购物</li>
              <li class="nav_list_item" :class="{active: isActive=='生活'}" @click="getLife">生活</li>
            </ul>
            <ul class="nav_content" v-if="educationList">
              <li class="nav_content_item" v-for="(item,index) in educationList" @click="gotoMap(item.point)" :key="index">
                <div class="nav_content_left">
                  <p class="nav_content_left_title">{{item.title}}</p>
                  <span class="nav_content_left_address">{{item.address}}</span>
                </div>
                <!-- <span class="nav_content_left_distance">{{item.distance}}米</span> -->
              </li>
              <!-- <li v-if="educationList.length==0" style="text-align:center;line-height:50px;color:#999999;">暂无信息</li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import VueCookies from "vue-cookies";
import { dicGet } from "@/api";
import { domPageSize } from "../../vue/util/tool";
import {
  communityDetail,
  communityUpdate,
  communityDelete,
  departmentUpdate,
  communityAddImg,
  communityEditImg,
  queryResidentialAreaCount,
  topResidentialArea,
  setCoverPicture,
} from "@/api/manageCenter";
import { queryTopStatus } from "@/api/houseManage";
import AddBuildAlert from "@/components/common/addBuild";
import AddDoorModel from "@/components/common/newAddDoorModel";
import UploadImg from "@/components/common/uploadImg";
import {
  housetypeAdd,
  houseTypeQuery,
  housetypeUpdate,
  deleresidentialAreatePicture,
  houseTypeDelete,
} from "@/api/houseManage";
import axios from "axios";
import { constants } from "crypto";
// import func from '../../../vue-temp/vue-editor-bridge';
export default {
  name: "CommunityDetail",
  data() {
    let token = sessionStorage.getItem("accessToken") || "";
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      input: "",
      headers: { accessToken: token },
      imgListShow: false, //图片列表弹窗
      imgListShowIndex: 0, //图片列表索引
      images: [],
      areaOfBuilding: "",
      curImgList: [],
      curimgSta: "houseTypeImg",
      areaImgIndex: "",
      activeName: "houseTypeImg",
      isActive: "",
      educationList: [],
      upLoadUrl: [],
      imgs: [],
      uploadToken: "",
      dialogVisible: false,
      isUpload: true,
      urlData: "http://file.gfwlkj.cn:8877/",
      dataUrl: "",
      isSave: false,
      isReadonly: true,
      isShow: true,
      AreaId: "",
      topDate: "",
      atTopVisible: false,
      uploadImgVisible: false,
      dialogTableVisible: false,
      newAdddoorModel: false,
      parkingWay: [],
      powerSupplyWay: [],
      waterSupplyWay: [],
      gasSupplyWay: [],
      heatingWay: [],
      buildTypeD: [],
      radio: "",
      doorModelData: [
        {
          uri: "",
          url: "",
          size: "",
        },
      ], //户型列表

      elseModeDara: [
        {
          uri: "",
          url: "",
          size: "",
        },
      ], //其他图片列表
      areaImgList: [],
      scrollData: "",
      trafficData: "",
      matchData: "",
      areaImageurl: "",
      residentialAreaPicture: [
        {
          uri: "",
          size: "",
          url: "",
        },
      ], //弹窗小区图片

      areaImages: [
        {
          uri: "",
          size: "",
          url: "",
        },
      ],

      bulidInfoCount: {
        vacantNumber: "", //空置数量
        setNumber: "", //总套数
        totalTungs: "", //小区总栋数
        saleNumber: "", //在售数量
        rentingNumber: "", //在租数量
        dealNumber: "", //成交数量
        builds: "", //栋数
        households: "", //户数
      },
      total: 0,
      PageSize: 0,
      PageNumber: 0,
      isTopShow: false,
      bulidInfo: {
        whetherOpen: true,
        showPermission: false,
        isTop: false,
        residentialAreaPicture: [],
        id: "", //小区编号
        areaId: "", //区域编号
        tradeAreaId: "", //商圈编号

        name: "", //小区名称
        longitude: "", //经度
        latitude: "", //纬度
        avgPrice: "", //均价

        architecturalType: [], //建筑类型
        developers: "", //开发商
        propertyCompany: "", // 物业公司
        propertyFee: "", //物业费
        propertyPhone: "", //物业电话
        areaCovered: "", //占地面积
        buildingCovered: "", //建筑总面积
        greenRate: "", // 绿化率
        volumeRate: "", //容积率
        parkingSpaces: "", //车位数量
        parkingMode: [], //停车方式
        parkingModeName: [],
        parkingFee: "", //停车费
        powerSupplyMode: "", //供电方式
        powerFee: "", //电费 元/度
        waterSupplyMode: "", //供水方式
        waterFee: "", // 水费 元/吨
        gasSupplyMode: "", //供气方式
        gasFee: "", // 燃气费 元/立方
        warmSupplyModel: "", // 供暖方式
        warmFee: "", //暖气费 元/月
        description: "", // 楼盘介绍
        nearbySchool: "", // 周边学校
        nearbyTraffic: "", // 周边交通
        nearbyMatch: "", //周边配套
        createTime: "", //创建时间
        updateTime: "", //更新时间
        nearbySchool: "", // 周边学校  query string
        nearbyTraffic: "", // 周边交通 query string
        nearbyMatching: "", // 周边配套query string
      },
      buildData: {
        nearbySchool: "", // 周边学校  query string
        nearbyTraffic: "", // 周边交通 query string
        nearbyMatch: "", //周边配套
      },
      towardData: [],
      areaFmId: "",
      searchCtiy: "",
      isOptytion: 0,
      iActive: 0,
      oPicLis: 0,
      oBtn: [],
      oBtnLis: [],
      buildLng: "",
      buildLat: "",
      isgetimage: false,
    };
  },
  inject: ["ispc"],
  mounted() {
    let width = this.$refs.bscroll.offsetWidth;
    let height = 3;
    let itemwidth = 160;
    let itemheight = 1;
    this.PageSize = domPageSize(width, height, itemwidth, itemheight) - 1;
    this.getGasSupplyWay();
    this.getPowerSupplyWay();
    this.getWaterSupplyWay();
    this.getParkingWay();
    this.getHeatingWay();
    this.getBuildTypeData();
    this.getAreaPMFind();
    this.getBuilding();
    console.log("asdajshd", this.PageSize);

    this.getTowardData();
    this.queryResidentialAreaCount();
  },

  watch: {
    "$store.state.top": function () {
      if (this.$store.state.top > 100) {
        if (!this.isgetimage) {
          this.gethouseTypeList();
        }
        this.isgetimage = true;
      }
    },

    areaOfBuilding: function () {
      this.PageNumber = 0;
      this.gethouseTypeList();
    },

    topDate: function () {
      let regNumber = /^\+?[1-9][0-9]*$/;
      if (!regNumber.test(this.topDate)) {
        this.topDate = "";
      }
    },
  },

  components: {
    AddBuildAlert,
    AddDoorModel,
    UploadImg,
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    handleClick(tab, event) {
      this.gethouseTypeList();
      if (this.activeName == "houseTypeImg") {
      } else {
        this.elseModeDara = this.bulidInfo[this.activeName];
      }
    },

    // 配套地图
    gotoMap(data) {
      this.bulidInfo.longitude = data.lng;
      this.bulidInfo.latitude = data.lat;
      this.initMap();
    },

    // 初始化地图
    initMap(val) {
      let map = new BMap.Map("container"); // 创建地图实例
      //  //cosole.log(22222222,this.bulidInfo.longitude,this.bulidInfo.latitude)
      let point = new BMap.Point(
        this.bulidInfo.longitude,
        this.bulidInfo.latitude
      ); // 创建点坐标
      map.centerAndZoom(point, 100); // 初始化地图，设置中心点坐标和地图级别

      const that = this;

      var local = new BMap.LocalSearch(map, {
        renderOptions: {
          map: map,
          autoViewport: true,
          panel: "result",
        },
        onSearchComplete: function (results) {
          console.log(123, results);
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            // that.educationList = results.$q;
            that.educationList = results.Ar;
          }
        },
      });
      local.searchInBounds(val ? val : this.isActive, map.getBounds());
    },

    // 获取户型列表
    gethouseTypeList() {
      let id = sessionStorage.getItem("residentialAreaId");
      let params = {
        residentialAreaId: id,
        "page.pageNumber": this.PageNumber,
        "page.pageSize": this.PageSize,
        areaOfBuilding: this.areaOfBuilding,
      };
      this.$post(houseTypeQuery, params).then((res) => {
        if (res.success) {
          this.total = res.total;
          this.doorModelData = res.data;
        }
      });
    },
    handleCurrentChange(val) {
      console.log(3333333333333333, this.PageSize);
      this.PageNumber = (val - 1) * this.PageSize;
      this.gethouseTypeList();
    },
    getTowardData() {
      let params = {
        code: "orientation",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          this.towardData = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    // 保存上传图片
    upLoadingBtn(data) {
      //cosole.log(232323,data)
      sessionStorage.setItem("communitydelet", "del");
      let residentialAreaId = sessionStorage.getItem("residentialAreaId");
      if (this.curimgSta == "residentialAreaPicture") {
        var params = {
          residentialAreaPicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.residentialAreaPicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.curimgSta == "trafficPicture") {
        //cosole.log(13432423423432,this.bulidInfo.trafficPicture)
        var params = {
          trafficPicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.trafficPicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.curimgSta == "matchingPicture") {
        var params = {
          matchingPicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.matchingPicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.curimgSta == "planningPicture") {
        var params = {
          planningPicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.planningPicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.curimgSta == "templatePicture") {
        var params = {
          templatePicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.templatePicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.curimgSta == "effectPicture") {
        var params = {
          effectPicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.effectPicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      } else if (this.curimgSta == "exteriorPicture") {
        var params = {
          exteriorPicture: JSON.stringify(data),
          residentialAreaId: residentialAreaId,
        };
        if (!this.bulidInfo.exteriorPicture) {
          this.$post(communityAddImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          this.$post(communityEditImg, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.uploadImgVisible = false;
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      }
    },
    removeUpLoadingBtn() {
      this.imgs = [];
      this.upLoadUrl = [];
      this.uploadImgVisible = false;
    },
    editBasisInfo() {
      this.$router.push({ path: "CommunityEdit" });
    },
    delBasisInfo() {
      this.$confirm("此操作将永久删除该小区, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            residentialAreaId: this.bulidInfo.residentialAreaId,
          };
          this.$post(communityDelete, params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              sessionStorage.setItem("communitydelet", "del");
              this.$router.push("CommunityList");
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    queryResidentialAreaCount() {
      // 楼盘详情统计
      let id = sessionStorage.getItem("residentialAreaId");
      let params = {
        residentialAreaId: id,
      };
      this.$post(queryResidentialAreaCount, params).then((res) => {
        if (res.success) {
          this.bulidInfoCount = res.data;
        }
      });
    },

    topResidentialArea() {
      // 小区置顶

      // return
      let parms = {
        residentialAreaId: sessionStorage.getItem("residentialAreaId"),
        topStatus: this.bulidInfo.isTop ? 0 : 1,
        // topDate: this.topDate
      };
      this.$post(topResidentialArea, parms).then((res) => {
        if (res.success) {
          let msg = this.bulidInfo.isTop
            ? "取消置顶成功"
            : "置顶成功";
          this.$message.success(msg);
          sessionStorage.setItem("communitydelet", "del");
          this.atTopVisible = false;
          this.queryTopStatus();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    queryTopStatus() {
      let permisList1 = JSON.parse(sessionStorage.getItem("permisList1"));
      if (this.permisShow("置顶")) {
        this.isTopShow = true;
      } else {
        this.isTopShow = false;
      }
      let params = {
        residentialAreaId: sessionStorage.getItem("residentialAreaId"),
      };
      this.$post(queryTopStatus, params).then((res) => {
        if (res.success) {
          this.bulidInfo.isTop = res.data.isTop;
          this.bulidInfo.showPermission = res.data.showPermission;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 楼盘详情
    getBuilding() {
      let permisList1 = JSON.parse(sessionStorage.getItem("permisList1"));
      let id = sessionStorage.getItem("residentialAreaId");
      // let permissionLevel = 0;
      // if (this.permisShow("置顶")) {
      //   permisList1.map(item => {
      //     if (item.functionName == "置顶") {
      //       permissionLevel = item.level;
      //     }
      //   });
      // } else {
      //   permissionLevel = 6;
      // }
      let params = {
        residentialAreaId: id,
        // permissionLevel: permissionLevel
      };
      this.$post(communityDetail, params).then((res) => {
        if (res.success) {
          this.bulidInfo = res.data;
          this.queryTopStatus();
          if (this.bulidInfo.architecturalTypeName) {
            this.bulidInfo.architecturalTypeName = this.bulidInfo.architecturalTypeName.join(
              ","
            );
          }
          if (this.bulidInfo.parkingModeName) {
            this.bulidInfo.parkingModeName = this.bulidInfo.parkingModeName.join(
              ","
            );
          }
          this.initMap(this.bulidInfo.address);
          this.elseModeDara = this.bulidInfo[this.activeName];
          if (this.bulidInfo.exteriorPicture.length != 0) {
            this.areaImgList = this.bulidInfo.exteriorPicture;
          } else {
            if (this.bulidInfo.matchingPicture.length != 0) {
              this.areaImgList = [
                ...this.bulidInfo.matchingPicture,
              ];
            } else if (this.bulidInfo.planningPicture.length != 0) {
              this.areaImgList = [
                ...this.bulidInfo.planningPicture,
              ];
            } else if (
              this.bulidInfo.residentialAreaPicture.length != 0
            ) {
              this.areaImgList = [
                ...this.bulidInfo.residentialAreaPicture,
              ];
            } else if (this.bulidInfo.matchingPicture.length != 0) {
              this.areaImgList = [
                ...this.bulidInfo.matchingPicture,
              ];
            } else if (this.bulidInfo.templatePicture.length != 0) {
              this.areaImgList = [
                ...this.bulidInfo.templatePicture,
              ];
            } else if (this.bulidInfo.trafficPicture.length != 0) {
              this.areaImgList = [
                ...this.bulidInfo.trafficPicture,
              ];
            } else if (this.bulidInfo.effectPicture.length != 0) {
              this.areaImgList = [
                ...this.bulidInfo.effectPicture,
              ];
            }
          }
          //cosole.log(1111111111111111111,this.areaImgList)
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询建筑类型
    getBuildTypeData() {
      let params = {
        code: "areaArchitecturalType",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          //cosole.log(res, '建筑类型')
          this.buildTypeD = res.data;
        }
      });
    },
    // 查询停车方式
    getParkingWay() {
      let params = {
        code: "parkingMode",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          //cosole.log(res, '停车方式')
          this.parkingWay = res.data;
        }
      });
    },
    // 查询供电方式
    getPowerSupplyWay() {
      let params = {
        code: "powerSupplyMode",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          //cosole.log(res, '供电方式')
          this.powerSupplyWay = res.data;
        }
      });
    },
    // 查询供水方式
    getWaterSupplyWay() {
      let params = {
        code: "waterSupplyMode",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          //cosole.log(res, '供水方式')
          this.waterSupplyWay = res.data;
        }
      });
    },
    // 查询供气方式
    getGasSupplyWay() {
      let params = {
        code: "gasSupplyMode",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          //cosole.log(res, '供气方式')
          this.gasSupplyWay = res.data;
        }
      });
    },
    // 查询供暖方式
    getHeatingWay(val) {
      let params = {
        code: "warmSupplyModel",
      };
      this.$post(dicGet, params).then((res) => {
        if (res.success) {
          //cosole.log(res, '供暖方式')
          this.heatingWay = res.data;
        }
      });
    },
    // 建筑类型选择按钮
    chouseTypeBtn(i, data) {
      this.isActive = i;
      this.communityInfo.buildType = data.value;
      //cosole.log(this.communityInfo.buildType)
    },
    // 停车方式选择按钮
    chouseParkTypeBtn(i, data) {
      this.isActive2 = i;
      this.communityInfo.parkWay = data.value;
      //cosole.log(this.communityInfo.parkWay)
    },
    // 取消保存
    removeBtn() {
      this.dialogTableVisible = false;
    },
    // 设置当前图片列表
    setCurImg(item, data, index) {
      this.imgListShowIndex = index;
      this.curImgList = Object.assign({}, data);
      this.imgListShow = true;
    },
    handleAvatarSuccess(file) {
      this.curImgList[this.imgListShowIndex].imagesNew = {
        uri: file.uri,
        size: file.size,
        url: file.uri,
      };
      this.curImgList[this.imgListShowIndex].images = file.uri;
    },
    updateImg(data) {
      let params = Object.assign({}, data);
      if (params.imagesNew) {
        let arr = [
          {
            uri: "",
            url: "",
            size: "",
          },
        ];
        arr[0].uri = params.imagesNew.uri;
        arr[0].url = params.imagesNew.uri;
        arr[0].size = params.imagesNew.size;
        params.images = JSON.stringify(arr);
        delete params.imagesNew;
      } else {
        delete params.images;
        delete params.imagesNew;
      }

      if (!params.roomNumber) {
        this.$message({
          message: "室数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.officeNumber) {
        this.$message({
          message: "厅数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.toiletNumber) {
        this.$message({
          message: "卫数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.balconyNumber) {
        this.$message({
          message: "阳台数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.areaOfBuilding) {
        this.$message({
          message: "建筑面积不能为空",
          type: "error",
        });
        return;
      }
      if (!params.areaOfUse) {
        this.$message({
          message: "套内面积不能为空",
          type: "error",
        });
        return;
      }
      this.$post(housetypeUpdate, params).then((res) => {
        if (res.success) {
          this.gethouseTypeList();
          this.$message.success(res.msg);
          this.imgListShow = false;
        } else {
          this.$message.success(res.msg);
        }
      });
    },
    setCover(item) {
      let id = sessionStorage.getItem("residentialAreaId");
      let params = {
        coverPictureUrl: item,
        residentialAreaId: id,
      };
      this.$post(setCoverPicture, params).then((res) => {
        if (res.success) {
          this.$message.success("设置成功");
          this.imgListShow = false;
          this.getBuilding();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deletImg1(id) {
      let params = {
        houseTypeId: id,
      };
      this.$post(houseTypeDelete, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msg);
          this.imgListShow = false;
          sessionStorage.setItem("communitydelet", "del");
          this.gethouseTypeList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deletImg(url) {
      let params = {
        pictureType: this.activeName,
        uri: url,
        residentialAreaId: sessionStorage.getItem("residentialAreaId"),
      };
      this.$post(deleresidentialAreatePicture, params).then((res) => {
        if (res.success) {
          this.$message.success(res.msg);
          this.imgListShow = false;
          sessionStorage.setItem("communitydelet", "del");
          this.getBuilding();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 管理栋楼
    addBuildBtns() {
      this.dialogTableVisible = true;
    },
    cancelBtn() {
      this.isReadonly = true;
      this.isShow = true;
      this.getBuilding();
    },
    // 修改小区信息
    modifyAreaUpdata() {
      let params = this.bulidInfo;
      this.$post(communityUpdate, params).then((res) => {
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.isReadonly = true;
          this.isShow = true;
          this.getBuilding();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 查询小区配套
    getAreaPMFind() {
      let mepId = sessionStorage.getItem("employeeId");
      let Id = sessionStorage.getItem("areaId");
      let params = {
        employeeId: mepId,
        areaId: Id,
      };
    },
    // 添加小区配套
    addAreaFm(params) {
      if (
        params.school === "" &&
        params.traffic === "" &&
        params.matching === ""
      ) {
        this.dialogTableVisible = false;
      } else {
        this.isSave = true;
        let mepId = sessionStorage.getItem("employeeId");
        let Id = sessionStorage.getItem("areaId");
        params.employeeId = mepId;
        params.areaId = Id;
        resquestAreaPMAdd(params).then((res) => {
          if (res.success) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.isSave = false;
            this.dialogTableVisible = false;
            this.areaId = res.data.areaId;
            this.getAreaPMFind();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
    // 修改小区配套
    modifyAreaFm() {
      this.bulidInfo.nearbySchool = this.buildData.nearbySchool;
      this.bulidInfo.nearbyTraffic = this.buildData.nearbyTraffic;
      this.bulidInfo.nearbyMatch = this.buildData.nearbyMatch;
      let params = this.bulidInfo;
      this.$post(communityUpdate, params).then((res) => {
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.dialogTableVisible = false;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    openUploadImg(data) {
      //cosole.log(1111111111111,data)
      this.residentialAreaPicture = [
        {
          uri: "",
          url: "",
          size: "",
        },
      ];
      this.uploadImgVisible = true;
      //cosole.log(1232132,this.activeName)
      if (data) {
        this.curimgSta = data;
      } else {
        this.curimgSta = this.activeName;
        //cosole.log(1232132,this.curimgSta)
      }
    },
    closeBtn() {
      this.imgs = [];
      this.upLoadUrl = [];
      this.isSave = false;
    },
    // 新增户型弹出框
    uploadDoorModel() {
      this.newAdddoorModel = true;
    },
    goBuildingManagement() {
      let id = sessionStorage.getItem("residentialAreaId");
      sessionStorage.setItem("newresidentialAreaId", id);
      sessionStorage.setItem("households", this.bulidInfo.households);
      sessionStorage.setItem("areaName", this.bulidInfo.name);
      this.$router.push({ path: "/CommunityBuilds" });
    },
    peitaoEdit() {
      this.dialogTableVisible = true;
      sessionStorage.setItem("communitydelet", "del");
      this.buildData.nearbySchool = this.bulidInfo.nearbySchool;
      this.buildData.nearbyTraffic = this.bulidInfo.nearbyTraffic;
      this.buildData.nearbyMatch = this.bulidInfo.nearbyMatch;
    },
    removeSaveEditBtn() {
      this.dialogTableVisible = false;
    },
    rmoveDoorBtnAler() {
      this.newAdddoorModel = false;
    },
    saveDoorBtnAler(data) {
      let param = Object.assign({}, data);
      param.residentialAreaId = sessionStorage.getItem(
        "residentialAreaId"
      );
      param.images = JSON.stringify(param.images);
      //cosole.log(data)
      // return
      let params = param;
      if (!params.roomNumber) {
        this.$message({
          message: "室数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.officeNumber) {
        this.$message({
          message: "厅数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.toiletNumber) {
        this.$message({
          message: "卫数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.balconyNumber) {
        this.$message({
          message: "阳台数不能为空",
          type: "error",
        });
        return;
      }
      if (!params.areaOfBuilding) {
        this.$message({
          message: "建筑面积不能为空",
          type: "error",
        });
        return;
      }
      if (!params.areaOfUse) {
        this.$message({
          message: "套内面积不能为空",
          type: "error",
        });
        return;
      }
      // if (!params.images){
      //   this.$message({
      //     message:'请上传户型图',
      //     type:'error'
      //   });
      //   return
      // }
      this.$post(housetypeAdd, params).then((res) => {
        if (res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.newAdddoorModel = false;
          this.gethouseTypeList();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
      // axios.requestDoorModelAdd.headers = {'Content-Type' : 'application/json;charset-UTF-8'}
    },
    removeDoorModel(data) {
      let empId = sessionStorage.getItem("employeeId");
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            employeeId: empId,
            id: data.id,
          };
          requestDoorModelDelete(params).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              sessionStorage.setItem("communitydelet", "del");
              this.getBuilding();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getTraffic(keyType) {
      this.isActive = "公交";
      this.initMap();
    },
    getEducation(keyType) {
      this.isActive = "教育";
      this.initMap();
    },
    getMedical(keyType) {
      this.isActive = "医疗";
      this.initMap();
    },
    getShopping(keyType) {
      this.isActive = "购物";
      this.initMap();
    },
    getLife(keyType) {
      this.isActive = "生活";
      this.initMap();
    },
    changePic() {
      function byid(id) {
        return document.getElementById(id);
      }

      function bytag(tag, obj) {
        return (typeof obj === "object"
          ? obj
          : byid(obj)
        ).getElementsByTagName(tag);
      }
      this.oBtn = byid("tFocus-btn");
      this.oBtnLis = bytag("li", this.oBtn);

      if (this.iActive === 0) {
        this.doMove(bytag("ul", this.oBtn)[0], "left", 0);
        //cosole.log(bytag('ul', this.oBtn))
      } else if (this.iActive >= this.oPicLis - 2) {
        this.doMove(
          bytag("ul", this.oBtn)[0],
          "left",
          -(this.oPicLis - 3) * (this.oBtnLis[0].offsetWidth + 4)
        );
        //cosole.log(bytag('ul', this.oBtn))
      } else {
        this.doMove(
          bytag("ul", this.oBtn)[0],
          "left",
          -(this.iActive - 1) * (this.oBtnLis[0].offsetWidth + 4)
        );
        //cosole.log(bytag('ul', this.oBtn))
      }
    },
    doMove(obj, attr, iTarget) {
      let that = this;
      clearInterval(obj.timer);
      obj.timer = setInterval(function () {
        let iCur = 0;
        if (attr === "opacity") {
          iCur = parseInt(parseFloat(that.getStyle(obj, attr)) * 100);
        } else {
          iCur = parseInt(that.getStyle(obj, attr));
        }
        var iSpeed = (iTarget - iCur) / 6;
        iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);
        if (iCur === iTarget) {
          clearInterval(obj.timer);
        } else {
          if (attr === "opacity") {
            obj.style.filter =
              "alpha(opacity:" + (iCur + iSpeed) + ")";
            obj.style.opacity = (iCur + iSpeed) / 100;
          } else {
            obj.style[attr] = iCur + iSpeed + "px";
          }
        }
      }, 30);
    },
    getStyle(obj, attr) {
      if (obj.currentStyle) {
        return obj.currentStyle[attr];
      } else {
        return getComputedStyle(obj, false)[attr];
      }
    },
    leftBtn() {
      this.iActive--;
      this.isOptytion--;
      if (this.iActive === -1) {
        this.iActive = this.oPicLis - 1;
        this.isOptytion = this.oPicLis - 1;
      }
      if (this.oPicLis > 3) {
        this.changePic();
      }
    },
    rightBtn() {
      this.iActive++;
      this.isOptytion++;
      if (this.iActive === this.oPicLis) {
        this.iActive = 0;
        this.isOptytion = 0;
      }
      if (this.oPicLis > 3) {
        this.changePic();
      }
    },
    theSelected(i) {
      this.iActive = i;
      if (this.oPicLis > 3) {
        this.changePic();
      }
    },
    downLoadImg(item) {
      // 下载图片
      sessionStorage.setItem("downImg", item);
      this.$electron.ipcRenderer.send("open-directory-dialog");
    },
  },
};
</script>


<style type="text/css" lang="less" >
.buildDetails {
  display: block !important;
  margin: 0;
  background: #ffffff !important;
  height: 100vh;
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
  .el-select .el-tag {
    margin: 0;
    border: none;
    background: #ffffff;
  }
  .el-select__tags {
    min-width: 1500px !important;
  }
  .el-select .el-tag {
    float: left;
    padding: 0;
    padding-right: 8px;
  }
  .el-select__tags-text {
    font-size: 16px;
    color: #333;
  }
  .mask .el-carousel__item {
    background: transparent;
    opacity: 1 !important;
  }
  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9;
    .close {
      width: 20px;
      position: absolute;
      top: 100px;
      right: 180px;
      padding: 50px;
      z-index: 100;
    }
    .delet {
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 150px;
      z-index: 100;
      height: 38px;
      /*height: auto !important;*/
    }
    .edit {
      height: 38px;
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 30px;
      z-index: 100;
      /*height: auto !important;*/
    }
    .setCover {
      width: 100px;
      display: flex;
      justify-content: center;
      border: none;
      background: #5e75e6;
      color: #ffffff;
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 390px;
      z-index: 100;
      height: auto !important;
    }
    .download {
      border: none;
      background: #22ca85;
      color: #ffffff;
      position: absolute;
      padding-left: 36px;
      padding-right: 36px;
      bottom: 0;
      right: 270px;
      z-index: 100;
      height: auto !important;
    }

    .el-carousel__container {
      width: 90%;
      // margin: 200px auto;
      min-width: 1440px;
      height: 90vh;
      z-index: 99;
      .el-carousel__arrow {
        font-size: 50px !important;
        padding: 20px;
        width: 100px;
        height: 100px;
      }
      // .el-carousel__arrow--left,.el-carousel__arrow--right{

      // }
    }

    .el-carousel__item {
      color: #475669;
      font-size: 18px;
      opacity: 0.75;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      // min-height: 400px;
      .uploadtime {
        width: 100%;
        line-height: 24px;
        color: #fff;
        position: absolute;
        left: 100px;
        bottom: 0;
      }
      > img {
        width: 70%;
        height: 80%;
      }
    }
    .door_modle_introduced {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      padding: 0 100px;
      .introduced_toward {
        display: flex;
        flex-direction: column;
        > span {
          font-size: 14px;
          color: #ffffff;
        }

        .el-textarea {
          margin-top: 10px;
          .el-textarea__inner {
            width: 260px;
            height: 60px;
            background: #f5f5f5;
            border: 1px solid #ccc;
          }
        }
      }
      .el-select {
        margin-top: 10px;
        .el-input {
          .el-input__inner {
            padding-left: 10px !important;
            font-size: 16px !important;
            width: 100px !important;
            height: 30px !important;
            line-height: 30px !important;
            background: #f5f5f5;
            border: 1px solid #ccc !important;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
    }
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-bottom: 1px solid #5e75e6;
  }

  .el-tabs--card > .el-tabs__header {
    border-bottom: 2px solid #5e75e6;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: #5e75e6;
    color: #ffffff;
    border-bottom: 2px solid #5e75e6;
  }
  .el-input.is-disabled .el-input__inner {
    color: black;
  }
  .el-select {
    .el-input {
      .el-input__inner {
        height: 16px;
        line-height: 16px !important;
        padding-left: 0;
        border: none;
        font-size: 16px;
      }

      .el-input__suffix {
        display: none;
      }

      .el-input__icon {
        line-height: 30px;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background: none;
    }
  }
}
// .el-select {
//     width: 300px;
// }
// .el-icon-arrow-left:before {
//   content: "111" !important;
//   padding: 0 20px;
//   color: #cccccc;
//   font-size: 12px;
// }

// .el-icon-arrow-right:before {
//   content: "2";
//   padding: 0 20px;
//   color: #cccccc;
//   font-size: 12px;
// }
</style>
<style type="text/css" lang="less" >
.buildDetails {
  display: flex;
  flex-direction: column;
  min-width: 1200px;

  .top_background {
    height: 20px;
  }
  .door_model_info {
    font-size: 14px;
    color: #333333;
    padding-left: 100px;
    .door_model_info_item {
      color: #fff;
      > div {
        width: 180px;
        height: 30px;
        display: flex;
        align-items: center;
        color: #000;
        background: #f5f5f5;
        margin-top: 10px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #ccc;
        input {
          width: 30px;
          height: 100%;
          background: #f5f5f5;
          outline: none;
          text-align: center;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }
        input[type="number"] {
          -moz-appearance: textfield;
        }
      }
    }
    .door_model_area {
      margin-top: 20px;
      .door_model_area_title {
        color: #fff;
        display: flex;
        justify-content: space-between;
        .el-switch {
          line-height: 14px;
          .el-switch__core {
            height: 14px;
            width: 30px !important;
          }
          .el-switch__core:after {
            width: 10px;
            height: 10px;
          }
          .el-switch__label {
            color: #5e75e6;
          }
          .el-switch__label * {
            font-size: 12px;
          }
          .el-switch__label.is-active {
            color: #333333;
          }
        }
        .el-switch.is-checked .el-switch__core::after {
          margin-left: -10px;
        }
      }
      .door_model_input {
        width: 300px;
        height: 30px;
        background: #f5f5f5;
        border-radius: 4px;
        overflow: hidden;
        margin-top: 10px;
        border: 1px solid #ccc;
        .check_no {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          > input {
            background: #f5f5f5;
            height: 100%;
            flex: 1;
            outline: none;
          }
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          input[type="number"] {
            -moz-appearance: textfield;
          }
          span {
            font-size: 14px;
            color: #333333;
          }
        }
        .check_ture {
          width: 100%;
          height: 100%;
          display: flex;
          .check_ture_item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px;
            > input {
              width: 100%;
              height: 100%;
              background: #f5f5f5;
              outline: none;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none;
            }
            input[type="number"] {
              -moz-appearance: textfield;
            }
          }
          .check_ture_item:first-child,
          .check_ture_item:nth-child(2) {
            border-right: 1px solid #ccc;
          }
        }
      }
    }
  }

  .buildDetails_main {
    background: white;
    flex: 1;
    padding: 20px;

    .buildDetails_header {
      display: flex;

      #tFocus {
        width: 420px;
        // height: 300px;
        // border: 1px solid red;

        overflow: hidden;
        // margin: 30px auto 0 auto;

        #tFocus-pic {
          width: 420px;
          height: 300px;
          position: relative;
          overflow: hidden;
          border: 1px solid #ccc;
          box-sizing: border-box;
          border-radius: 4px;

          li {
            width: 420px;
            height: 300px;
            box-sizing: border-box;
            border-radius: 4px;
            position: absolute;
            left: 0;
            top: 0;
            // width: 100%;
            // height: 100%;
            // filter: alpha(opacity:0);
            opacity: 0;

            > img {
              width: 100%;
              height: 100%;
            }

            &.active {
              opacity: 1;
            }
          }
        }

        #tFocusBtn {
          width: 420px;
          height: 100px;
          padding-left: 5px;
          margin-top: 5px;
          z-index: 20;
          display: flex;
          align-items: center;
          background: #ddd;
          border-radius: 4px;

          // border: 1px solid blue;
          #tFocus-btn {
            width: 370px;
            height: 100px;
            position: relative;
            left: 0;
            bottom: 0;
            overflow: hidden;
            float: left;
            margin-right: 3px;
            box-sizing: border-box;

            > ul {
              width: 100000px;
              height: 68px;
              position: absolute;
              left: 0;
              top: 0;

              > li {
                height: 80px;
                width: 118px;
                padding-top: 7px;
                display: block;
                float: left;
                margin-right: 5px;

                > img {
                  width: 100%;
                  height: 100%;
                  border: 2px solid #dddddd;
                }

                &.active {
                  display: block;
                  // background: url(img/spr.png) no-repeat;
                  // background: url(../../../assets/images/spr.png) no-repeat;
                  background-position: -435px -100px;

                  > img {
                    border: 2px solid #40b9e5;
                  }
                }
              }
            }
          }
        }

        #tFocus-leftbtn,
        #tFocus-rightbtn {
          height: 40px;
          width: 15px;
          float: left;
          text-indent: -9999px;
          display: block;
          // background: url(img/spr.png) no-repeat;
          // background: url(../../../assets/images/spr.png) no-repeat;
        }

        #tFocus-leftbtn {
          margin-right: 5px;
          background-position: -455px -60px;
        }

        #tFocus-rightbtn {
          margin-left: 2px;
          background-position: -480px -60px;
        }
      }
      .el-dialog {
        width: 600px;

        .el-dialog__title {
          color: #5e75e6;
          font-size: 20px;
        }

        .el-dialog__close {
          font-size: 24px;
        }

        .el-dialog__body {
          padding: 30px 0 0 0;
          .leaveRequest_content {
            padding: 20px 30px 0 30px;
            .item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              &_div {
                flex: 1;
                display: flex;
                align-items: center;
                padding: 10px 0;
                .el-checkbox-group {
                  margin: 0;
                  .el-checkbox__label {
                    > span {
                      padding: 0 2px;
                      color: red;
                    }
                  }
                }
                .label {
                  min-width: 100px;
                  display: inline-block;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  text-align: right;
                  .notice {
                    color: #ff0000;
                  }
                }
                .el-input__icon {
                  line-height: 26px;
                }
                .el-radio {
                  padding: 5px 0;
                }
                .el-input {
                  width: 80px;
                  height: 26px;
                  margin-right: 20px;
                  .el-input__inner {
                    width: 80px;
                    height: 26px;
                    padding: 0 10px;
                    height: 26px;
                  }
                }
              }
            }
          }
        }
        .dialog-foot {
          text-align: right;
          margin-top: 50px;
          background: #f5f5f5;
          padding: 20px;
          .foot-cancel,
          .foot-save {
            width: 80px;
            height: 40px;
            border: none;
            outline: none;
            border-radius: 4px;
            font-size: 16px;
            color: #ffffff;
            margin-right: 20px;
          }
          .foot-cancel {
            background: #cccccc;
          }
          .foot-save {
            background: #5e75e6;
          }
        }
      }

      .house_icon {
        width: 420px;
        height: 100%;
        border: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999999;
        cursor: pointer;
      }

      .header_content {
        margin-left: 26px;
        flex: 1;
        .header_content_text {
          color: #ff3e3e;
          .house_status {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .header_content_title {
          display: flex;
          justify-content: space-between;
          margin-top: 14px;
          align-items: center;
          .content_house_name {
            min-width: 120px;
            > p {
              font-size: 30px;
              color: #666666;
              font-weight: 500;
              padding-bottom: 10px;
            }

            > span {
              font-size: 14px;
              color: #999999;
            }
          }

          .icon-icon_zhiding,
          .icon-icon_quxiaozhiding {
            font-size: 32px;
            color: #ff3e3e;
          }

          .house_price {
            min-width: 140px;
            font-size: 14px;
            color: #999999;
            padding-left: 50px;
            > span {
              font-size: 30px;
              color: #ff3e3e;
              padding-right: 5px;
            }
          }
          .house_status {
            height: 56px;
            font-size: 16px;
            color: #ff3e3e;
            padding-left: 70px;
            display: flex;
            align-items: center;
          }

          .manange_btn {
            width: 120px;
            height: 30px;
            background: #22ca85;
            outline: none;
            border: none;
            color: white;
            font-size: 14px;
            border-radius: 4px;
            margin-left: 30px;
          }

          .edit_btn {
            width: 120px;
            height: 30px;
            background: #5e75e6;
            outline: none;
            border: none;
            color: white;
            font-size: 14px;
            border-radius: 4px;
            margin-left: 30px;
          }
          .del_btn {
            width: 120px;
            height: 30px;
            background: #ff3e3e;
            outline: none;
            border: none;
            color: white;
            font-size: 14px;
            border-radius: 4px;
            margin-left: 30px;
          }
        }
        .info_list {
          display: flex;
          margin-top: 40px;

          .iconfont {
            color: white !important;
            font-size: 30px !important;
            padding: 10px;
            border-radius: 50%;
          }

          &.second {
            margin-top: 70px;
          }

          .info_list_item {
            flex: 1;
            display: flex;
            align-items: center;
            padding-left: 10px;
            position: relative;

            .iconfont {
              font-size: 55px;
              color: #5e75e6;
            }

            .list_item_size {
              margin-left: 20px;
              color: #666666;

              .size_num {
                font-size: 30px;
              }

              .size_beizhu {
                font-size: 14px;
                margin-top: 5px;
                text-align: center;
              }
            }

            .management_router {
              position: absolute;
              font-size: 14px;
              color: #5e75e6;
              top: -20px;
              right: 40px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }

    .basis_info,
    .model_info {
      border-left: 1px solid #dadada;
      border-right: 1px solid #dadada;
      .basis_info_title {
        height: 40px;
        font-size: 16px;
        color: #333;
        font-weight: bold;
        line-height: 40px;
        background: #f2f4ff;
        border-top: 1px solid #dadada;
        position: relative;
        .icon_title {
          margin: 0 13px;
          display: inline-block;
          width: 6px;
          height: 16px;
          background: rgba(94, 117, 230, 1);
          border-radius: 3px;
        }
        .dict_search_select {
          position: absolute;
          right: 30px;
          top: 60px;
          display: flex;
          padding: 10px 0;
          z-index: 8;
          .dict_select_item {
            min-width: 130px;
            margin-left: 20px;
            height: 30px;
            display: flex;
            align-items: center;
            font-size: 12px;

            .year {
              padding: 4px 8px;
              min-width: 30px;
              color: #666;
            }
            .el-select {
              width: 80px;
              .el-input__inner {
                border: none;
                padding: 0px;
                padding-left: 10px;
                height: 30px;
                // background: #f5f5f5;
                border: 1px solid #dbdbdb;
                border-radius: 3px;
                width: 80px;
              }
              .el-input__icon {
                line-height: 30px !important;
              }

              .el-input__suffix {
                right: 0;
              }
            }

            .el-input {
              width: 200px;
              .el-input__inner {
                border: none;
                padding: 0px;
                padding-left: 10px;
                height: 30px;
                // background: #f5f5f5;
                border: 1px solid #dbdbdb;
                border-radius: 3px;
                // width: 0px;
              }
            }

            &.item_years {
              display: flex;
              align-items: center;

              .el-input {
                width: 80px;
                .el-input__inner {
                  padding: 0 5px;
                  border: none;
                  text-align: center;
                }
              }
            }

            &.item_price {
              border-right: none;
            }
          }
        }
        > span {
          display: flex;
          align-items: center;

          .icon-icon_yewuxinxi,
          .icon-icon_huxing {
            font-size: 30px;
          }
        }

        > button {
          width: 100px;
          height: 40px;
          background: #f5f5f5;
          outline: none;
          border: none;
          color: #5e75e6;
          font-size: 14px;
          border-radius: 4px;
          margin-right: 300px;
        }

        .el-dialog {
          width: 460px;

          .el-dialog__title {
            color: #5e75e6;
            font-size: 20px;
          }

          .el-dialog__close {
            font-size: 24px;
          }

          .el-dialog__body {
            padding: 30px 0 0 0;
          }
        }
      }

      .basis_info_list,
      .model_info_list {
        // width: 100%;
        font-size: 16px;
        color: #999999;
        padding: 10px 30px 30px 30px;
        .basis_info_list_item {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 8px 0;
          &_form {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex: 1;
          }
          &_label {
            color: #999;
            min-width: 100px;
            text-align: right;
          }
          &_content {
            flex: 1;
            color: #333;
          }
        }

        // .basis_info_list_item {
        //     width: 25%;
        //     position: relative;
        //     > p {
        //         margin-top: 20px;
        //         > span {
        //             color: #333333;
        //         }
        //         .houzhui {
        //             color: #333333;
        //         }
        //         input {
        //             width: 120px;
        //         }
        //         .inp {
        //             cursor: pointer;
        //         }
        //     }
        // }
      }

      .basi_info_editorBtn {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        padding-right: 160px;
        > button {
          width: 80px;
          height: 40px;
          font-size: 16px;
          color: white;
          border: none;
          outline: none;
          background: #999999;
          border-radius: 4px;
          margin-left: 20px;
          &.save {
            background: #5e75e6;
          }
        }
        &.active {
          display: none;
        }
      }

      .bscroll {
        // height: 140px;
        // overflow: hidden;
        position: relative;
        padding: 0;
        // margin-right: 300px;
      }

      .model_info_list {
        &_box {
          // max-width: 1200px;
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          align-items: top;
          //   overflow-x: auto;
        }
        .model_info_list_item {
          min-width: 140px;
          max-width: 140px;
          margin-right: 20px;
          margin-top: 10px;
          position: relative;
          overflow: hidden;
          border-radius: 4px;
          .bianji {
            width: 72px;
            height: 72px;
            position: absolute;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 100%;
            left: 0;
            top: 0;
            margin-left: -36px;
            margin-top: -36px;

            .icon-icon_bianji {
              font-size: 24px;
              position: absolute;
              right: 10px;
              bottom: 10px;
              color: white;
            }
          }

          .remove {
            width: 72px;
            height: 72px;
            position: absolute;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 100%;
            right: 0;
            top: 0;
            margin-right: -36px;
            margin-top: -36px;

            .icon-icon_shanchu {
              font-size: 24px;
              position: absolute;
              left: 10px;
              bottom: 10px;
              color: white;
            }
          }

          .model_info_img {
            border: 1px solid #ccc;
            width: 140px;
            height: 100px;
            // padding: 10px 20px 6px 20px;

            // margin-right: 20px;
            overflow: hidden;
            position: relative;
            .img_fengmian {
              width: 30px;
              height: auto;
              position: absolute;
              top: 0;
              right: 0;
              z-index: 8;
            }
            > img {
              width: 100%;
              height: 100%;
            }
          }

          .model_info_text {
            font-size: 12px;
            color: #333333;
            display: flex;
            justify-content: space-between;
            margin-top: 6px;

            .fangxiang {
              padding-left: 10px;
            }
          }
        }
        .upload_img_box {
          width: 140px;
          height: 100px;
          background: #f5f5f5;
          border: 1px solid #cccccc;
          border-radius: 4px;
          display: flex;
          // margin-left: 20px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          .upload_input_invisible {
            position: absolute;
            border: 1px solid red;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
          .icon-icon_huxing {
            font-size: 28px;
            color: #999999;
          }
          > span {
            font-size: 14px;
          }
          .up_text {
            position: absolute;
            bottom: 0;
            height: 30px;
            color: black;
            font-weight: 600;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            width: 100%;
            background: white;
            opacity: 0.5;
          }
        }
      }

      .building_note {
        padding: 30px;
        font-size: 16px;
      }
    }

    .building_info {
      border-left: 1px solid #dadada;
      border-right: 1px solid #dadada;
      .building_info_title {
        border-top: 1px solid #dadada;
        height: 40px;
        font-size: 16px;
        color: #333;
        line-height: 40px;
        background: #f2f4ff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
          font-weight: bold;
        }
        .icon_title {
          margin: 0 13px;
          display: inline-block;
          width: 6px;
          height: 16px;
          background: rgba(94, 117, 230, 1);
          border-radius: 3px;
        }
        > button {
          width: 100px;
          height: 40px;
          background: #f5f5f5;
          outline: none;
          border: none;
          color: #5e75e6;
          font-size: 14px;
          border-radius: 4px;
          margin-right: 300px;
        }

        .left {
          display: flex;
          align-items: center;

          .icon-icon_zhuzhai,
          .icon-icon_zhoubianpeitao {
            font-size: 30px;
          }
        }

        .guan_btn {
          width: 100px;
          height: 40px;
          border: none;
          outline: none;
          background: #f5f5f5;
          font-size: 14px;
          color: #5e75e6;
        }
      }
      .el-dialog {
        width: 600px;

        .el-dialog__title {
          color: #5e75e6;
          font-size: 20px;
        }

        .el-dialog__close {
          font-size: 24px;
        }

        .el-dialog__body {
          padding: 0;
        }

        .edit_alert {
          .edit_alert_list {
            padding: 0 40px;

            .edit_alert_list_item {
              margin-top: 30px;

              > h3 {
                font-size: 14px;
                color: #333333;
              }

              .el-textarea {
                margin-top: 10px;

                .el-textarea__inner {
                  background: #f5f5f5;
                  border: 1px solid #ccc;
                  height: 90px;
                }
              }
            }
          }

          .edit_footer_btns {
            height: 80px;
            background: #f5f5f5;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 40px;
            padding-right: 40px;

            .el-button {
              width: 80px;
              height: 40px;
              background: #999999;
              border-radius: 4px;
              outline: none;
              border: none;
              color: white;
              font-size: 16px;
              margin-left: 20px;

              &.save_btn {
                background: #5e75e6;
              }
            }
          }
        }
      }
      .building_info_list {
        margin: 30px;
        box-sizing: border-box;

        .building_info_list_item {
          font-size: 16px;
          margin-top: 10px;
          color: #333333;
        }
      }

      .address_box {
        margin: 30px;
        height: 400px;
        border: 4px solid #cccccc;
        border-radius: 8px;
        margin-top: 20px;
        position: relative;

        .amap-page-container {
          position: absolute;
          right: 30px;
          top: 40px;
          background: white;
          width: 300px;
          height: 330px;
          display: flex;
          flex-direction: column;

          .nav_list_box {
            display: flex;
            background: #f5f5f5;

            .nav_list_item {
              height: 30px;
              flex: 1;
              line-height: 30px;
              text-align: center;
              border-top: 4px solid #f5f5f5;
              // box-sizing: border-box;
              font-size: 14px;
              color: #999999;
              cursor: pointer;

              &.active {
                border-top: 4px solid #5e75e6;
                background: white;
                color: #5e75e6;
              }
            }
          }

          .nav_content {
            flex: 1;
            overflow: hidden;
            overflow-y: scroll;

            .nav_content_item {
              display: flex;
              justify-content: space-between;
              font-size: 13px;
              // height: 50px;
              box-sizing: border-box;
              border-bottom: 1px solid #f5f5f5;
              padding: 10px 15px 6px 11px;
              cursor: pointer;
              .nav_content_left {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .nav_content_left_title {
                  color: #333333;
                }

                .nav_content_left_address {
                  line-height: 18px;
                  color: #999999;
                  margin-top: 4px;
                }
              }

              .nav_content_left_distance {
                color: #999999;
              }
            }
          }

          .nav_content::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }
  }
  .footer_page {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 30px;
    background: #f5f5f5;
    padding: 10px 30px;
    .data_number {
      font-size: 12px;
      margin-right: 10px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #5e75e6;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      border: 1px solid #ccc;
      background: white;
    }

    // .el-icon-arrow-left:before {
    //   content: "上一页";
    //   padding: 0 20px;
    //   color: #cccccc;
    //   font-size: 12px;
    // }

    // .el-icon-arrow-right:before {
    //   content: "下一页";
    //   padding: 0 20px;
    //   color: #cccccc;
    //   font-size: 12px;
    // }
  }
}
</style>
